import React from "react";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import "./PainterServiceSections.css";

const PainterCtaBanner = () => {
  return (
    <section className="pnt-cta">
      <div className="pnt-container pnt-cta-inner">
        <div className="pnt-cta-icon">
          <FormatPaintIcon fontSize="inherit" />
        </div>
        <div className="pnt-cta-copy">
          <h2>Give Your Home a Fresh New Look</h2>
          <p>
            Book a free consultation with our expert painters today and get a personalised colour
            plan crafted for your space.
          </p>
        </div>
        <a href="#painter-quote-form" className="pnt-cta-btn">
          Book a Painter
        </a>
      </div>
    </section>
  );
};

export default PainterCtaBanner;
